import { StackProps, VStack } from '@cdl/heartbeat-react';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren & StackProps;

export const SidebarSection: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <VStack
      spacing='m'
      alignItems='stretch'
      p='m'
      bgColor='white'
      borderRadius='4px'
      shadow={400}
      {...rest}
    >
      {children}
    </VStack>
  );
};
